import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import useStyles from './styles';

const Slot = ({setPath, data}) => {

  const classes = useStyles();

  return <Grid container justify='space-around' align='center'>
    <Grid item xs={12}>
      <Typography className={classes.text}>
        {`Horário: ${data.calendarT}`}
      </Typography>
      <Typography className={classes.text}>
        {`Status: ${data.statusT}`}
      </Typography>
    </Grid>
    <Grid item>
      <Button color="primary" onClick={() => setPath('event')}>
        Novo Evento
      </Button>
    </Grid>
    <Grid item>
      <Button color="primary" onClick={() => setPath('update')}>
        Modificar
      </Button>
    </Grid>
    <Grid item>
      <Button color="primary" onClick={() => setPath('delete')}>
        Apagar
      </Button>
    </Grid>
    <Grid item>
      <Button color='secondary' onClick={() => setPath('root')}>
        Fechar
      </Button>
    </Grid>
  </Grid>;
};

export default Slot;
